import { GsFormSchema } from '../../../components';
import { GsStructTextAlignment } from '../../../models';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { borderSchemaFields } from './../basics/border.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { PAGINATED_SCHEMA_FIELDS } from './../basics/paginated.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * Form schema for the PlantDoctor component settings in the designer. The start category comes
 * from the UserControl's backend dialog, so it is not listed here.
 */
export const PLANT_DOCTOR_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...PAGINATED_SCHEMA_FIELDS,
    {
      formControlName: 'showPhotos',
      label: 'components.plantDoctor.schema.showPhotos',
      type: 'checkbox',
      default: true,
      groupingName: 'schema.items.name'
    },
    {
      formControlName: 'forceSquareImage',
      label: 'schema.items.forceSquareImage',
      type: 'checkbox',
      default: false,
      if: {
        args: [{ formControlName: 'showPhotos', value: true }]
      }
    },
    {
      formControlName: 'itemImageHeight',
      label: 'schema.items.itemImageHeight',
      type: 'number',
      isResponsive: true,
      default: { default: 200 },
      if: {
        chaining: 'and',
        args: [
          { formControlName: 'showPhotos', value: true },
          { formControlName: 'forceSquareImage', value: false }
        ]
      }
    },
    ...borderSchemaFields('ItemImage', undefined, 'schema.border.name'),
    {
      formControlName: 'itemZoomOnHover',
      label: 'components.plantDoctor.schema.itemZoomOnHover',
      type: 'checkbox',
      default: false,
      if: {
        args: [{ formControlName: 'showPhotos', value: true }]
      }
    },
    {
      formControlName: 'itemTextAlignment',
      label: 'schema.alignment.text.name',
      type: 'select',
      valueType: 'number',
      default: GsStructTextAlignment.center,
      options: [
        { text: 'schema.alignment.text.left', value: GsStructTextAlignment.left },
        { text: 'schema.alignment.text.center', value: GsStructTextAlignment.center },
        { text: 'schema.alignment.text.right', value: GsStructTextAlignment.right }
      ]
    },
    {
      formControlName: 'stepActiveBackgroundColor',
      label: 'components.plantDoctor.schema.stepActiveBackgroundColor',
      type: 'color',
      default: 'primary-main',
      groupingName: 'components.plantDoctor.schema.steps'
    },
    {
      formControlName: 'stepActiveTextColor',
      label: 'components.plantDoctor.schema.stepActiveTextColor',
      type: 'color',
      default: 'primary-contrast',
      groupingName: 'components.plantDoctor.schema.steps'
    },
    {
      formControlName: 'buttons',
      label: 'components.plantDoctor.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
